import BaseComponent from '../base-component/base-component'

class RecipientForm extends BaseComponent {
  constructor() {
    super()

    this.checkbox = this.querySelector(`[data-recipient-form-checkbox]`)
    this.timezoneInput = this.querySelector(
      `[data-recipient-form-timezone-input]`,
    )
    this.inputs = this.querySelectorAll(
      '[data-recipient-form-input], [data-recipient-form-timezone-input]',
    )
    this.fields = this.querySelector('[data-recipient-form-fields]')

    this.timezoneInput.value = new Date().getTimezoneOffset()
  }

  connectedCallback(): void {
    this.addEventListener('change', this.handleChange)
  }

  disconnectedCallback(): void {
    this.removeEventListener('change', this.handleChange)
  }

  handleChange(): void {
    const isChecked = this.checkbox.checked

    this.updateMaxHeight(isChecked)

    this.updateInputDisable(!isChecked)

    if (!isChecked) {
      this.clearInputs()
    }
  }

  clearInputs(): void {
    this.inputs.forEach(input => {
      input.value = ''
    })
  }

  updateInputDisable(isDisabled: boolean): void {
    this.inputs.forEach(field => {
      field.disabled = isDisabled
    })
  }

  reset(): void {
    this.checkbox.checked = false

    this.clearInputs()
  }

  updateMaxHeight(isChecked: boolean): void {
    if (!this.fields) {
      return
    }

    const height = isChecked ? this.fields.scrollHeight : 0

    this.fields.style.maxHeight = `${height}px`
  }
}

export default RecipientForm
